module.exports = __webpack_public_path__ + "img/Efectiva.734c22ae.svg";